export const processBacklogIssuesCollections = (project) => {

	return [
		...project.Sprints,
		{
			Id: null,
			Issues: project.Issues
		}
	];
};

export const processBoardIssuesCollections = (sprint) => {
	return [ sprint.TodoIssues, sprint.DevelopmentIssues, sprint.TestingIssues, sprint.DoneIssues ];
};

export const getNewIssuesCollections = (oldList, dragItem, targetItem, assignee = null) => {
	let newList = JSON.parse(JSON.stringify(oldList));
	let movedIssue = newList[dragItem.current.parentIndex].Issues.splice(dragItem.current.index, 1)[0];
	if (assignee) {
		movedIssue = { ...movedIssue, Assignee: assignee };
	}
	newList[targetItem.parentIndex].Issues.splice(targetItem.index, 0, movedIssue);
	return newList;
};

export const getUnCompletedIssuesCount = (collection) => {
	return collection.filter((x) => x.Title !== 'Done').reduce((acc, curr) => {
		return acc + curr.Issues.length;
	}, 0);
};

export const getCompletedIssuesCount = (collection) => {
	return collection.filter((x) => x.Title === 'Done')[0].Issues.length;
};
